<template>
  <div v-if="!currentMenu.isShow" :style="userData.isAndroid ? 'height: 13vh;' : 'height: 64px;'"
    style="width: 100vw; position: fixed; z-index: 999; top: 0; left: 0">
    <section class="d-flex flex-column-reverse common-header-revamp common-header-textbox-revamp"
      v-if="userData.channel != 'WEB'">
      <b-row class="row no-gutters">
        <b-col cols="2" align-self="center" class="object-center">
          <div v-if="currentMenu.previousPage != ''" @click="goToPreviousPage()"
            class="d-flex justify-content-center align-self-center common-shadow" style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              align-items: center;
            ">
            <b-img width="24" height="24" style="cursor: pointer" :src="backArrowLeft"></b-img>
          </div>
        </b-col>
        <b-col cols="8" align-self="center">
          <div class="justify-content-center align-self-center" style="display: flex">
            <div class="text-header-center text-revamp-color-black font-anuphan-bold-20">
              {{ currentMenu.pageName }}
            </div>
          </div>
        </b-col>
        <b-col cols="2" align-self="center" class="object-center">
          <div class="d-flex justify-content-center align-self-center common-shadow"
            style="width: 40px; height: 40px; border-radius: 50%" v-if="currentMenu.previousPage == ''"
            @click="goToPreviousPage()">
            <svg style="width: 24px" class="w-3 h-3 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </b-col>
      </b-row>
    </section>

    <div class="container-lg pr-5 pl-5 mb-4" v-if="userData.channel == 'WEB'">
      <div class="row">
        <div class="col-12">
          <div class="container-lg pr-5 pl-5">
            <div class="bs-stepper linear">
              <div class="bs-stepper-header">
                <div class="step active text-center">
                  <span class="bs-stepper-circle">1</span><br />
                  <span class="bs-stepper-label">เข้าสู่ระบบ</span>
                </div>
                <div class="bs-stepper-line bg-white" v-if="step >= 1"></div>
                <div class="step text-center" v-if="step >= 1" v-bind:class="{ active: step >= 1 }">
                  <span class="bs-stepper-circle">2</span><br />
                  <span class="bs-stepper-label">รายละเอียด</span>
                </div>
                <div class="bs-stepper-line bg-white" v-if="step >= 1"></div>
                <div class="step text-center" v-if="step >= 1" v-bind:class="{ active: step >= 2 }">
                  <span class="bs-stepper-circle">3</span><br />
                  <span class="bs-stepper-label">อัปโหลดเอกสาร</span>
                </div>
                <div class="bs-stepper-line bg-white"></div>
                <div class="step text-center" v-bind:class="{ active: step >= 3 }">
                  <span class="bs-stepper-circle" v-if="step >= 1">4</span>
                  <span class="bs-stepper-circle" v-else>2</span><br />
                  <span class="bs-stepper-label">สรุป</span>
                </div>
              </div>
              step
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentMenu: Object,
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    step() {
      let step = -1;
      if (this.$route.name.includes("Login")) step = 0;
      else if (this.$route.name.includes("Main")) step = 1;
      else if (
        this.$route.name.includes("Upload") ||
        this.$route.name.includes("ListAccountPage") ||
        this.$route.name.includes("DstatementPage") ||
        this.$route.name.includes("DocumentGroupPage")
      )
        step = 2;
      else if (this.$route.name.includes("Summary")) step = 3;
      return step;
    },
  },
  data() {
    return {
      modalShowBackStep: false,
      modalShowBackStep2: false,
      imgSystemClose: require("@/assets/images/ic_close.png"),
      iconBack: require("@/assets/images/Back Arrow Icon.png"),
      backArrowLeft: require("@/assets/images/Arrow-narrow-left.png"),
    };
  },

  methods: {
    goToPreviousPage() {
      let param = this.currentMenu.params;
      // console.log("this.currentMenu.pageCode", this.currentMenu.pageCode);
      if (
        ["CommonStatementDocument", "CommonPreUpload"].includes(
          this.currentMenu.pageCode
        )
      ) {
        this.$event.$emit("onGoBackCallback");
      } else if (
        ["CommonLanding", "CommonExampleDocTypeGroup"].includes(
          this.currentMenu.pageCode
        )
      ) {
        this.$event.$emit("onExitCallback");
      } else {
        if (param != undefined && param.grpId != undefined) {
          this.$router.push({
            name: this.currentMenu.previousPage,
            params: { grpId: param.grpId },
          });
        } else {
          this.$router.push({
            name: this.currentMenu.previousPage,
          });
        }
        this.$event.$emit("onExitCallback");
      }
    },
  },
};
</script>
<style>
.text-color-NEXT {
  color: #5b6171 !important;
}

.border {
  border: 1px solid #8a8a8a !important;
}

.border-radius-1rem {
  border-radius: 1rem !important;
}

.bg-grey {
  background-color: #fff !important;
}

.text-label {
  color: #727a8d !important;
}

.card-body {
  color: #2f2f2f !important;
}

.badge-info {
  color: #fff;
  background-color: #1ba2de;
}

.b-card-haeder {
  font-weight: bolder;
  font-size: 1rem;
}
</style>
<style scoped>
.icon-back {
  color: #00a7ec;
}

.btn-back-step {
  width: inherit;
  color: #00a3e4;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: unset;
}
</style>
